import { GET_BPT_PREFERENCE_ANALYSIS_AWARENESS_ASYNC } from './actions';

export const awarenessTabReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_BPT_PREFERENCE_ANALYSIS_AWARENESS_ASYNC.actions.SUCCEEDED:
            return action.payload;
        case GET_BPT_PREFERENCE_ANALYSIS_AWARENESS_ASYNC.actions.FAILED:
            return {};
        default:
            return state;
    }
};
